export default __webpack_public_path__ + "static/media/icon-cal.ffd78e89.svg";